import React, {memo} from 'react';
import BrowserChecker from "../components/browser-checker";

const Testing = () => {

    return (
        <>
            <BrowserChecker />
        </>
    );
}

export default memo(Testing);